var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-wait',{attrs:{"for":_vm.name}},[_c('template',{slot:"waiting"},[_c('div',{staticClass:"page-loader"},[_c('clip-loader',{staticClass:"center",attrs:{"loading":true,"color":"#cc5100","size":"120px"}})],1)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }